/** Faixa discreta "nova versão disponível" — aparece quando há deploy novo. */
import { useEffect, useState } from "react";
import { aplicarAtualizacao, assinarAtualizacao } from "../lib/pwaUpdate.ts";

export function AvisoAtualizacao() {
  const [disponivel, setDisponivel] = useState(false);
  useEffect(() => assinarAtualizacao(setDisponivel), []);
  if (!disponivel) {
    return null;
  }
  return (
    <div
      role="alert"
      style={{
        position: "fixed",
        left: "50%",
        bottom: 16,
        transform: "translateX(-50%)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 14px",
        borderRadius: 12,
        background: "var(--text)",
        color: "var(--surface)",
        boxShadow: "0 6px 24px rgba(0,0,0,.25)",
        fontSize: "var(--text-sm)",
        maxWidth: "min(92vw, 420px)",
      }}
    >
      <span>Nova versão disponível.</span>
      <button
        type="button"
        onClick={() => aplicarAtualizacao()}
        style={{
          border: 0,
          borderRadius: 8,
          padding: "6px 12px",
          fontWeight: 600,
          cursor: "pointer",
          background: "var(--surface)",
          color: "var(--text)",
        }}
      >
        Atualizar
      </button>
    </div>
  );
}
